module.exports = __webpack_public_path__ + "static/5-f1412672d3e767b913988149bd7ad9ab.jpg";